<template>
    <Breadcrumbs main="Job Search" title="List View" />
    <div class="container-fluid">
        <div class="row">
            <jobSidebar />
            <jobList />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const jobSidebar = defineAsyncComponent(() => import("@/components/commen/jobSidebar.vue"))
const jobList = defineAsyncComponent(() => import("@/components/theme/job/list/jobList.vue"))
</script>